export default __webpack_public_path__ + "static/map-15a1e9841e0e7a089339fda59faaf0fc.jpg";